<script setup lang="ts">
  const { isDesktop } = useBTBreakpoints()
</script>

<template>
  <footer
    class="flex md:items-center md:justify-between"
    :aria-label="$t('fsf.footer.title')"
  >
    <div v-if="isDesktop">
      <FsfVoucher />
    </div>

    <FsfFooterActionBlock />
  </footer>
</template>
